import { useQuery } from '@tanstack/react-query';

import { toastError } from 'common/toast';
import { getIntegration } from 'api/integrations';

import { APIKeys } from 'common/enum/api-keys.enum';

export const useIntegrations = () => {
  const { data, refetch, isFetching } = useQuery<any[]>({
    placeholderData: [],
    queryFn: () => fetchData(),
    queryKey: [APIKeys.INTEGRATIONS],
  });

  const fetchData = async (): Promise<any[]> => {
    try {
      const { content } = await getIntegration();

      return content.integrations;
    } catch (error) {
      toastError('Failed to fetch Integrations', error);

      throw error;
    }
  };

  return {
    data,
    refetch,
    isLoading: isFetching,
  };
};
